var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarSvgrepoCom1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.901 489.901",
    style: {
      enableBackground: "new 0 0 489.901 489.901"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 124.8,
    cy: 213.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 213.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.1,
    cy: 213.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.8,
    cy: 352.15,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 352.15,
    r: 20.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.1,
    cy: 352.15,
    r: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.2,55.05h-48.9v-21.8c0-11.4-9.4-20.8-20.8-20.8s-20.8,9.4-20.8,20.8v21.8H110.3v-21.8c0-11.4-9.4-20.8-20.8-20.8 s-20.8,9.4-20.8,20.8v21.8H20.8C9.4,55.05,0,64.45,0,75.85v380.8c0,11.4,9.4,20.8,20.8,20.8h447.3c11.4,0,20.8-8.3,21.8-20.8 V75.85C490,64.45,480.6,55.05,469.2,55.05z M448.4,436.85H40.6V96.75h28.1v15.6c0,11.4,9.4,20.8,20.8,20.8s20.8-9.4,20.8-20.8 v-15.6h268.4v15.6c0,11.4,9.4,20.8,20.8,20.8c10.4,0,19.8-9.4,20.8-20.8v-15.6h28.1V436.85z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSvgrepoCom1);
export default __webpack_public_path__ + "static/media/calendar-svgrepo-com (1).1dc38b31.svg";
export { ForwardRef as ReactComponent };